import { effect, signal } from "@preact/signals";

export default class SearchQueryStore {
  readonly query = signal("");

  constructor(initialQuery = "") {
    this.query.value = initialQuery;
  }

  setQuery(query: string) {
    this.query.value = query;
  }

  onQueryChange(callback: (query: string, previousQuery: string) => void) {
    let previousQuery = this.query.value;
    return effect(() => {
      const query = this.query.value;
      if (query !== previousQuery) {
        const oldQuery = previousQuery;
        previousQuery = query;
        callback(query, oldQuery);
      }
    });
  }
}
